var _path, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-stroke",
    d: "m7.8,39.57c0-10.61,8.6-19.2,19.2-19.2s19,8.81,21.02,19.2",
    fill: "none",
    strokeWidth: "6.34px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "wasm-icon-fill wasm-icon-stroke",
    points: "52.41 44.81 34.03 38.58 56.2 25.78 52.41 44.81",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.49px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconRedo);
export default __webpack_public_path__ + "static/media/SDS_icon_Redo.479b6441a2260559b670b9a64edb8671.svg";
export { ForwardRef as ReactComponent };